import BezierEasing from 'bezier-easing'
import Highcharts from 'highcharts'
import { forEach } from 'ramda'

import { ReportDateHistogramType } from '@driftt/api-types'

export const resizeChartWidth =
  (
    widthOffset = 0,
    animation: boolean | Highcharts.AnimationOptionsObject = false
  ) =>
  (chart?: Highcharts.Chart) => {
    if (chart && chart.container.parentElement) {
      chart.setSize(
        chart.container.parentElement.offsetWidth + widthOffset,
        chart.chartHeight,
        animation
      )
    }
  }

// Same as CSS "ease": https://developer.mozilla.org/en-US/docs/Web/CSS/transition-timing-function
const cssEase = BezierEasing(0.25, 0.1, 0.25, 1)

export const offsetChartsWidth = (widthOffset: number, duration: number) => {
  forEach(
    resizeChartWidth(widthOffset, { duration, easing: cssEase }),
    Highcharts.charts
  )
}

export const reflowChartsWidth = () => {
  forEach(resizeChartWidth(), Highcharts.charts)
}

export const animateChartWidth = (duration: number): { cancel: () => void } => {
  let cancelled = false
  let start = 0

  const step = (timestamp: number) => {
    if (cancelled) {
      return
    }
    if (!start) {
      start = timestamp
    }
    reflowChartsWidth()
    const progress = timestamp - start
    if (progress < duration) {
      window.requestAnimationFrame(step)
    }
  }

  window.requestAnimationFrame(step)

  return {
    cancel: () => {
      cancelled = true
    },
  }
}

export const PointInterval: Record<ReportDateHistogramType, number> = {
  [ReportDateHistogramType.HOUR]: 3600 * 1000,
  [ReportDateHistogramType.DAY]: 24 * 3600 * 1000,
  [ReportDateHistogramType.WEEK]: 7 * 24 * 3600 * 1000,
  [ReportDateHistogramType.MONTH]: 31 * 24 * 3600 * 1000,
  [ReportDateHistogramType.QUARTER]: 91 * 24 * 3600 * 1000,
  [ReportDateHistogramType.YEAR]: 365 * 24 * 3600 * 1000,
}
